import React from 'react'
import TopBar from './TopBar'
import MainNav from './MainNav'

const Navbar: React.FC = () => {
  return (
    <header className="sticky top-0 z-50 bg-surface border-b border-border shadow-md transition-colors duration-250">
      <TopBar />
      <MainNav />
    </header>
  )
}

export default Navbar